import React from "react";
import Select from "../../Select";
import { DropdownProps } from "./Dropdown.types";

const Dropdown: React.FC<DropdownProps> = ({ options, selectedValue, onChange }) => (
  <Select
    options={options}
    value={selectedValue}
    onChange={(value) => onChange(Number(value))}
    ariaLabel="Количество отображаемых строк"
    minWidth="116px"
  />
);

export default Dropdown;
